import { render, staticRenderFns } from "./DashboardPaymentsMethodsList.vue?vue&type=template&id=26a1c224&"
import script from "./DashboardPaymentsMethodsList.vue?vue&type=script&lang=js&"
export * from "./DashboardPaymentsMethodsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports